import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-criteria-list',
  templateUrl: './criteria-list.component.html',
  styleUrls: ['./criteria-list.component.css']
})
export class CriteriaListComponent implements OnInit {
  public criteriaName: string;
  public selectedCriteriaId: any;
  constructor(public api: ApiService) { }

  ngOnInit() {
  }

  get savedCriterias() {
    return this.api.session.savedCriteria.filter(x => x.userView === this.api.session.selectedUserView);
  }

  deleteCriteria() {
    let request = this.api.deleteCriteria(this.selectedCriteriaId);
    request.successFunc = data => this.api.session.savedCriteria = data;
    request.start();
  }

  activateCriteria() {
    let request = this.api.getFullCriteria(this.selectedCriteriaId);
    request.successFunc = data => this.api.session.currentCriteria = data;
    request.start();
  }
}
